<!-- 模板 -->
<template>
    <div class = "footer_sum">
        <div class = "fill"></div>
        <div class="footer_parent">
            <div id = "footer" class = 'clearfloat'>
                <div class="pull-left left">
                    <p class = 'clearfloat' style="text-align:center;padding-bottom:4px;">
                        <a target = "_blank" :href="href"><span class = 'ml10'>鲁ICP备17056615号-6</span></a>
                        <span class = 'ml10 pointer'>人力资源服务许可证：<a href="https://img-cdn.zhaopinw.com/9ef79a7380e8f57ecc722615e77259f.jpg" target="_blank">(鲁)职介证字[2022]第01130105号</a></span>
                         <!-- <span class = 'ml10 pointer'>增值电信业务经营许可证：<a href="https://img-cdn.zhaopinw.com/667a956271b0b6a543c4ab6ed77e78c.jpg" target="_blank">鲁B2-20200642</a></span> -->
                    </p>
                    
                    <p class = 'clearfloat' style="text-align:center;">
                        <span class='ml10'>Copyright ©2017-2021 【朝聘网】 zhaopinw.com 【山东合聘信息技术有限公司】版权所有</span>
                        <span class="ml10">Shandong Hepin Information Technology Co., Ltd.</span>
                    </p>

                     <p class = 'clearfloat' style="text-align:center;padding:0 0 10px;">
                     
                       <span class="ml5 pointer" @click="openT(1)">关于我们</span>
                       <span class="ml5 pointer" @click="openT(2)">联系我们</span>
                       <span class="ml5">举报/投诉邮箱 info@91qiuzhi.cn</span>
                       <span class="ml5">单位地址：中国（山东）自由贸易试验区济南片区经十路7000号汉峪金谷A6-4号楼603</span>
                    </p>

                    
                </div>
                <div class="pull-right right">
                    <img :src = "footer_img" alt="">
                </div>
            </div>
        </div>

        <Modal 
        :title="title" 
        v-model = "show"
        footer-hide
        >
        <p>{{content}}</p>
        <p style="text-align:right">
            <Button type="primary" @click="show = false">确认</Button>
        </p>
        </Modal>
    </div>
</template>

<!-- css样式 -->
<style lang = "less" scoped>
/deep/ .ivu-modal-header {
    padding:10px 16px;
    background: #f5f5f5;
}
/deep/ .ivu-modal-close {
    top:4px;
}
    .footer_sum {
        margin-top: -100px;
    }
    .fill {
        width: 100%;
        height: 30px;
        background-color: #f4f5fa;
    }
    .footer_parent {
        width: 100%;
        background: #ffffff;
        overflow: hidden;
    }
    #footer {
        width: 1200px;
        margin: 0px auto;
        background: #ffffff;
        span {
            color: #6B6B6B;
            font-size: 14px;

        }
        .left {
            p:nth-child(1) {
                margin-top: 15px;
            }
            p:nth-child(2) {
                margin-top: 4px;
            }
            p {
                margin-top: 5px;
                span {
                    display: inline-block;
                    vertical-align: middle;
                }
                .width_1 {
                    width: 204px;
                    text-align: right;
                    margin-right: 15px;
                }
                .width_3 {
                    width: 300px;
                    text-align: center;
                    a {
                        color: #6B6B6B !important;
                    }
                }
                .width_4 {
                    width: 250px;
                    text-align: center;
                }
                .width_5 {
                    width: 400px;
                    text-align: center;
                     a {
                      color:#6B6B6B !important;
                    }
                }
                .pointer {
                    cursor: pointer;
                }
                .width_2 {
                    width: 590px;
                    text-align: left;
                }
            }
        }
        .right {
            width: 140px;
            img {
                width: 103px;
                height: 55px;
                display: block;
                margin: 0px auto;
                margin-top: 25px;
            }
        }
        .clearfloat:after {
            content: "";
            height: 0px;
            line-height: 0px;
            clear: both;
            visibility: hidden;
            display: block;
        }
        .pull-right {
            float: right;
        }
        .pull-left {
            float: left;
        }
        .ml10 {
            margin: 0 10px;
        }
        .ml5 {
            margin: 0 5px 0 0;
        }
    }
</style>

<!-- js动作 -->
<script>

    // 导入图片
    import footer_img from '../../../assets/images/foot_img.png';

    // 导出模板
    export default {

        // 表示名称
        name: "cu-footer",

        // 数据
        data: function() {

            return {

                // 底部图片
                footer_img,
                href: 'https://beian.miit.gov.cn/#/Integrated/index',
                show:false,
                title:'关于我们',
                content:'',
            }
        },
        methods:{
            openT(type) {
                if (type ===1) {
                    this.title = '关于我们'
                    this.content = '山东合聘信息技术有限公司创立于2017年 ，是以技术驱动的人力资源解决方案供应商，秉承“引领高潜人才，成就职业理想”的企业使命，专注于网络招聘、人才推荐、校招品宣、空中宣讲和中高端人才寻访（猎头）服务。'
                } else {
                    this.title = '联系我们'
                    this.content = '4001889091'
                }
                this.show = true
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/packages/Footer/CuFooter/Cu-Footer.vue